const getNumericValue = (value, skipValue = "") => {
  if (typeof value === "string" && value?.length) {
    const baseValue = value.replace(skipValue, "");
    const intValue = Number(baseValue);
    return !!intValue ? intValue : 0;
  } else if (typeof value === "number") {
    return value;
  } else {
    return 0;
  }
};

export default getNumericValue;
